module.exports = __webpack_public_path__ + "static/media/glanum_markt_tn.0003f07b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Provence/glanum_markt_tn.jpg
// module id = 720
// module chunks = 0